import React, { useState, useEffect } from 'react';
import '../assets/styles/scrollToTop.css';  
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';

const ScrollToTop = ({ scrollToElement }) => {
  const [isVisible, setIsVisible] = useState(false);

  // Function to toggle the visibility of the button based on scroll position
  const toggleVisibility = () => {
    if (window.pageYOffset > 1250) {
      setIsVisible(true);  // Show the button if scrolled more than 150px
    } else {
      setIsVisible(false); // Hide the button if scrolled less than 150px
    }
  };

  // Function to scroll to the specific element when button is clicked
  const scrollToTop = () => {
    if (scrollToElement && scrollToElement.current) {
      scrollToElement.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  // Add scroll event listener to track when to show/hide the button
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility); // Clean up the listener
    };
  }, []);

  return (
    <div className="scroll-to-top">
      {isVisible && (
        <div onClick={scrollToTop} className="scroll-button">
          <FontAwesomeIcon icon={faArrowUp} size="lg" />
        </div>
      )}
    </div>
  );
};

export default ScrollToTop;
